import { render, staticRenderFns } from "./UserLoginController.vue?vue&type=template&id=71898672&"
import script from "./UserLoginController.vue?vue&type=script&lang=ts&"
export * from "./UserLoginController.vue?vue&type=script&lang=ts&"
import style0 from "./UserLoginController.vue?vue&type=style&index=0&id=71898672&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports